// export const formatDate = (date) => {
//   var d = new Date(date),
//     month = '' + (d.getMonth() + 1),
//     day = '' + d.getDate(),
//     year = d.getFullYear();

//   if (month.length < 2) 
//       month = '0' + month;
//   if (day.length < 2) 
//       day = '0' + day;

//   return [year, month, day].join('-');
// }

export const formatDate = (input) => {
  const yyyy = input.getFullYear().toString().padStart(4, '0');
  const mm = (input.getMonth() + 1).toString().padStart(2, '0');
  const dd = input.getDate().toString().padStart(2, '0');
  
  return [yyyy, mm, dd].join('-');
}

export const getYear = (date) => Number(date.substr(0, 4))
export const getMonth = (date) => Number(date.substr(5, 2))
export const getDay = (date) => Number(date.substr(8, 2))
export const getUtcDate = (date) => new Date(Date.UTC(getYear(date), getMonth(date) - 1, getDay(date)))